import { IFieldProps } from "decorator-form";
import React from "react";

import { IUploadFieldOptions, UploadField } from "./UploadField";

/**
 * if you just want the file url, not the metadata
 */

interface IUploadUrlOptions extends IUploadFieldOptions {
	type?: string; // declare the type so you can have a preview
}

export function UploadUrlField({formData, onChange, ...restProps}: IFieldProps<string> & { options?: IUploadUrlOptions}) {
	return (
		<UploadField
			{...restProps}
			onChange={(o) => onChange(o.url)}
			formData={{
				url: formData,
				name: formData,
				type: restProps.options && restProps.options.type || undefined
			}}
		/>
	);
}

UploadUrlField.withOptions = (options: IUploadUrlOptions) => {
	return (props: IFieldProps<string>) => <UploadUrlField {...props} options={options} />;
};



// WEBPACK FOOTER //
// ./src/common/form/fields/upload/UploadUrlField.tsx